module.exports = __webpack_public_path__ + "static/slide1-318x245-91a7f339036fd1479c9cc0ed2baeefd7.gif";